import {makeStyles} from "@material-ui/core";

export const FPaquetesStyle = makeStyles((theme) => ({
  textField: {
    width: '90%',
    margin: "5px",
    paddingBottom: 0,
    fontWeight: 500
  },
  textFieldMultiLinea: {
    width: '95%',
    margin: "5px",
    paddingBottom: 0,
    fontWeight: 500
  },
  formControl: {
    width: "100%",
    margin: "5px",
    marginBottom: theme.spacing(3),
    '& .MuiInputLabel-root': {
      fontWeight: 500
    }
  },
  containerSpacingItem:{
    margin: "10px 10px"
  },
  modalBotonesCenter:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalBotones:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  modalBoton:{
    margin: "15px 10px",
    width: "35%"
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: "1200px",
    margin: "0 auto",
    padding: theme.spacing(1),
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    boxShadow: theme.shadows[10],
    padding: "1.5rem",
    minWidth: "50%"
  },
  imageTypeContainer: {
    display: "flex", 
    alignItems: "center", 
    flexDirection: "column" 
  }
}));
